import { Response } from './Response';

export class FormSecurityTokenResponse extends Response {
  get token() {
    return this.data?.token;
  }
}
